import { useEffect } from "react";

/**
 * Fires `callback` whenever the document becomes visible
 * (`visibilityState === "visible"`). On Tauri this fires on window-restore /
 * app-foreground; in the browser it fires on tab focus. The "hidden" half of
 * the event pair is filtered out — callers only run on real become-visible
 * transitions.
 *
 * Used for refreshing OS-mediated state that may have changed while the app
 * was in the background (permissions, calendar events, etc.).
 */
export function useOnVisible(callback: () => void): void {
  useEffect(() => {
    function handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        callback();
      }
    }
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [callback]);
}
